/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Pub_Tags_HintInputs */

const en_fw_pub_tags_hint = /** @type {(inputs: Fw_Pub_Tags_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comma-separated, up to 8.`)
};

const id_fw_pub_tags_hint = /** @type {(inputs: Fw_Pub_Tags_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pisahkan dengan koma, maksimal 8.`)
};

/**
* | output |
* | --- |
* | "Comma-separated, up to 8." |
*
* @param {Fw_Pub_Tags_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_pub_tags_hint = /** @type {((inputs?: Fw_Pub_Tags_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Pub_Tags_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_pub_tags_hint(inputs)
	return en_fw_pub_tags_hint(inputs)
});